var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalenderLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.4974 0.828125V2.49479H11.4974V0.828125H13.1641V2.49479H16.4974C16.9576 2.49479 17.3307 2.86789 17.3307 3.32812V16.6615C17.3307 17.1217 16.9576 17.4948 16.4974 17.4948H1.4974C1.03716 17.4948 0.664062 17.1217 0.664062 16.6615V3.32812C0.664062 2.86789 1.03716 2.49479 1.4974 2.49479H4.83073V0.828125H6.4974ZM15.6641 9.16146H2.33073V15.8281H15.6641V9.16146ZM8.16406 10.8281V14.1615H3.9974V10.8281H8.16406ZM4.83073 4.16146H2.33073V7.49479H15.6641V4.16146H13.1641V5.82812H11.4974V4.16146H6.4974V5.82812H4.83073V4.16146Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderLogo);
export default __webpack_public_path__ + "static/media/CalenderLogo.13be43b805c72711ca44cbd06a53f2b3.svg";
export { ForwardRef as ReactComponent };